import styled from 'styled-components';

export const AuthenticationContainer = styled.div`
    display: flex;
    width: 900px;
    justify-content: space-between;
    margin: 30px auto; 

    @media screen and (max-width: 1000px) {
        width: auto;
        flex-direction: column;
        gap: 25px;
        align-items: center;     
    }

`